import axios from "../../config/axiosConfig";
import {
  CREATE_PURCHASE_BILL_RETURNS, DELETE_PURCHASE_BILL_RETURNS,
  GET_PURCHASE_BILL_RETURNS_PAGE,
  GET_PURCHASE_BILL_RETURNS,
  PURCHASE_BILL_RETURNS_REQUEST,
  PURCHASE_BILL_RETURNS_REQUEST_SUCCESS,
  PURCHASE_BILL_RETURNS_REQUEST_FAILURE,
  UPDATE_PURCHASE_BILL_RETURNS,
  SET_PURCHASE_RETURN_ORDERS
} from "../types";

export const getPurchaseBillReturnsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id,Account_Id,Delivery_Account_Id,Lot_Id'
      };
      return axios.get("/purchase-bill-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_BILL_RETURNS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseBillReturns = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/purchase-bill-return/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_BILL_RETURNS, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPurchaseBillReturnsByRange = (bookId, billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId, billId, from, to
      };
      
      const response = await axios.get("/purchase-bill-return/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPurchaseBillReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
    
      return axios.get(`/purchase-bill-return/get/${id}`).then((response) => {
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createPurchaseBillReturn = (purchaseBillReturn) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const newPurchaseBillReturn = {
        ...purchaseBillReturn
      };
      return axios.post("/purchase-bill-return/add", newPurchaseBillReturn,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_PURCHASE_BILL_RETURNS, payload: response.data });
        } else {
          dispatch({
            type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE,
            error: "Purchase bill create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updatePurchaseBillReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      return axios.put("/purchase-bill-return/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_BILL_RETURNS,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE,
            error: "Purchase bill update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deletePurchaseBillReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      return axios.delete(`/purchase-bill-return/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_PURCHASE_BILL_RETURNS, id: id });
          const include = ['id', 'Entry_No', 'Challan_No', 'Book_Id', 'Date', 'Account_Id', 'Delivery_Account_Id', 'Original_Invoice_No', 'Lot_Id', 'Amount', 'Net_Total'].join(',');
          const searchCols = ['Entry_No', 'Challan_No'].join(',');
          const { inventory: { purchaseBillReturn: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getPurchaseBillReturnsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseReturnBillOrders = (id, bookId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      let params = {
        // finyearId: auth.finyear?.id,
        // companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        bookId,
        id
      };
      console.log('>>>>>common order', auth?.company?.Common_Order);
      if (!auth?.company?.Common_Order) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/purchase-bill-return/getRemainingOrders`, { params }).then((response) => {
        dispatch({
          type: SET_PURCHASE_RETURN_ORDERS,
          payload: response.data || [],
        });
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const cancelEwayPurchaseReturnBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      return axios.post(`/purchase-bill-return/cancel-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          // dispatch({ type: CANCEL_EWAY_BILL, id: id });
          dispatch({
            type: UPDATE_PURCHASE_BILL_RETURNS,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const extendValidityEwayPurchaseReturnBill = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      return axios.post(`/purchase-bill-return/extend-validity-eway-bill/${id}`, data, { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_BILL_RETURNS,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const printEwayPurcharseReturnBill = (ewaybillNumber) => {
  return async (dispatch, getState) => {
    try {
      console.log("Printing E-Way Bill with number:", ewaybillNumber);
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, ewaybillNumber };
      console.log("Params for printing E-Way Bill:", params);
      return axios.get("/purchase-bill-return/print-eway-bill", { params }).then((response) => {
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const generateEwayPurcharseReturnBill = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      
      return axios.get(`/purchase-bill-return/generate-eway-bill/${id}`,{ params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_PURCHASE_BILL_RETURNS,
            payload: { id, data: response.data },
          });
        }
        return response;
      }).catch((error) => {
        console.log('generate eway bill error',error);
        
        console.error(error);
        dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPurchaseBillByInvoiceNoInPurchaseReturn = (invoiceNo, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        finyearId: auth.finyear?.id,
        invoiceNo,
        bookId,
      };
      const res = await axios.get(`/purchase-bill-return/get-purchase-bill-by-invoice-no`, { params });
      return res?.data;
    } catch (error) {
      console.error(error);
    }
  };
};

export const getAllPurchaseBillByInvoiceNoInPurchaseReturn = (invNo, bookId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo,
        bookId: bookId,
      };
      return axios.get(`/purchase-bill-return/get-all-purchase-bill-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const sendMailPurchaseReturn = (mailData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('purchaseReturnId', mailData.purchaseReturnId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `purchase_return_${mailData.purchaseReturnId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/purchase-bill-return/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappPurchaseReturn = (whatsappData) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST });
      const { auth } = getState();
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('purchaseReturnId', whatsappData.purchaseReturnId);
      formData.append('finyearId', auth.finyear?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `purchase_return_${whatsappData.purchaseReturnId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/purchase-bill-return/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: PURCHASE_BILL_RETURNS_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: PURCHASE_BILL_RETURNS_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const getPincodeToPincodeDistanceGetPurchaseReturnBill = (purchaseReturnBillId, fromPincode) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        billId: purchaseReturnBillId,
        fromPincode
      };
      const response = await axios.get("/purchase-bill-return/get-pincode-to-pincode-distance", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};